<template>
    <div class="task-info" v-loading="loading">
        <div class="info-header" @click.self="changeState('isTaskInfoShow')">
            <div class="info-header-left">
                <span class="info-header-block"></span>
                <span class="info-header-text">运单信息</span>
                <span class="total-text">
                    ( 单量：<span @dblclick.stop="copyText($event)">{{ formateValue(basicInfo.taskCount) }}</span> /
                    计划数：<span @dblclick.stop="copyText($event)">{{ formateValue(basicInfo.totalQty) }}</span> /
                    实发数：<span @dblclick.stop="copyText($event)">{{ formateValue(basicInfo.qtyItemLoaded) }}</span> /
                    实收数：<span @dblclick.stop="copyText($event)">{{ formateValue(basicInfo.qtyItemSignoff) }}</span> /
                    计划方量：<span @dblclick.stop="copyText($event)">{{ formateValue(basicInfo.totalVolume) }}</span> m³ /
                    计划重量：<span @dblclick.stop="copyText($event)">{{ formateValue(basicInfo.totalGrossWeight) }}</span> KG /
                    实发方量<span @dblclick.stop="copyText($event)">{{ formateValue(basicInfo.loadedVolume) }}</span> m³ /
                    实发重量：<span @dblclick.stop="copyText($event)">{{ formateValue(basicInfo.loadedGrossWeight) }}</span> KG /
                    包裹数：<span @dblclick.stop="copyText($event)">{{ formateValue(basicInfo.sumPackages) }}</span> /
                    总包件数：<span @dblclick.stop="copyText($event)">{{ formateValue(basicInfo.totalPkgQty) }}</span> )
                </span>
            </div>
            <i :class="['el-icon', 'mgr-10', isTaskInfoShow ? 'el-icon-arrow-down' :'el-icon-arrow-right']"></i>
        </div>
        <div class="task-wrapper" v-show="isTaskInfoShow">
            <el-radio-group v-model="radio" @input="handleChangeRadio" style="margin: 5px auto;">
                <el-radio-button label="商品维度"></el-radio-button>
                <el-radio-button label="运单维度"></el-radio-button>
            </el-radio-group>
            <template v-if="!btnLoading">
                <goods-table-page
                    v-show="radio === '商品维度'"
                    :totalData="goodsInfo"
                    :pageLoading="pageLoading"
                    @handleSearch="goodsSearchChange"
                ></goods-table-page>

                <order-table-page
                    v-show="radio === '运单维度'"
                    :totalData="taskInfo"
                    :pageLoading="pageLoading"
                    @handleSearchByOrder="orderSearchChange"
                ></order-table-page>
            </template>
        </div>
    </div>
</template>

<script>
import { copyToClip } from '../util';
export default {
    name: 'TaskInformation',
    components: {
        goodsTablePage: () => import('./goodsTablePage.vue'),
        orderTablePage: () => import('./orderTablePage.vue')
    },
    props: {
        basicInfo: {
            type: Object,
            default () {
                return {};
            }
        },
        taskInfo: {
            type: Array,
            default () {
                return [];
            }
        },
        goodsInfo: {
            type: Array,
            default () {
                return [];
            }
        },
        btnLoading: {
            type: Boolean,
            default () {
                return false;
            }
        },
        pageLoading: {
            type: Boolean,
            default () {
                return false;
            }
        }
    },
    computed: {
        formateValue () {
            return function (val) {
                return (val !== null && val !== undefined && val !== '') ? val : '--';
            };
        }
    },
    activated () {
        if (this.$route.query.dispatchNo !== this.dispatchNoCopy) {
            this.dispatchNoCopy = this.$route.query.dispatchNo;
            this.orderParams = { dispatchNo: this.dispatchNoCopy };
            this.goodsParams = { dispatchNo: this.dispatchNoCopy };
        }
    },
    data () {
        return {
            radio: '商品维度',
            isTaskInfoShow: true,
            loading: false,
            taskNo: '',
            dispatchNoCopy: '',
            orderParams: {},
            goodsParams: {}
        };
    },
    methods: {
        changeState (state) {
            this[state] = !this[state];
        },
        copyText (e) {
            const value = (e.target.innerHTML).trim();
            value !== '--' && copyToClip(value);
        },
        handleChangeRadio () {
            this.loading = true;
            setTimeout(() => {
                this.loading = false;
            }, 1000);
        },
        orderSearchChange (data) {
            this.orderParams = data ? { ...data } : { dispatchNo: this.dispatchNoCopy };
            this.$emit('handleBatchSearch', this.goodsParams, this.orderParams);
        },
        goodsSearchChange (data) {
            this.goodsParams = data ? { ...data } : { dispatchNo: this.dispatchNoCopy };
            this.$emit('handleBatchSearch', this.goodsParams, this.orderParams);
        }
    }
};
</script>

<style lang="less" scoped>
@import '../dispatchInfoDetail.less';
.task-info {
    background-color: #fff;
    margin-bottom: 14px;
    .button-wrapper{
        margin-bottom: 6px;
        .el-button{
            font-size: 13px;
            padding-bottom: 0px;
            .daochu-text {
                margin-left: 5px;
            }
        }
    }
    .total-text {
        font-size: 14px;
        color: #999;
        margin-left: 10px;
    }
    .task-wrapper {
        padding: 0px 10px 0px 10px;
        /deep/.task-list {
            th {
                padding: 0 !important;
                height: 32px;
                line-height: 32px;
            }
            td {
                padding: 0 !important;
                height: 32px;
                line-height: 32px;
            }
        }
    }
    .product-dimension {
        /deep/ .vxe-table--render-wrapper .vxe-table--body-wrapper .vxe-table--main-wrapper {
            max-height: 700px;
        }
        .table-list-encrypted-panel {
            /deep/ .el-icon-document-copy {
                font-size: 15px;
                cursor: pointer;
                margin-left: 5px;
                color: var(--main-color);
            }
        }
    }
}
</style>
